import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=d6f58a7c&scoped=true&"
import script from "./RequestAccess.vue?vue&type=script&lang=js&"
export * from "./RequestAccess.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=d6f58a7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f58a7c",
  null
  
)

export default component.exports